// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class ArchivingTssTMO {

	public id: string = undefined;

	public name?: string = undefined;

	public businessPremisesId?: string = undefined;

	public fccId?: string = undefined;

	public tssSerialNumber?: string = undefined;

	public status?: ArchivingTssStatusEnum = undefined;

	public createdDate?: Date = undefined;

	public lastModifiedDate?: Date = undefined;

	public activationDate?: Date = undefined;

	public deactivationDate?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingTss extends ArchivingTssTMO {
	public etag?: string = undefined;

}

// INTERFACES ########################################################
// API interfaces ****************************************************

// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
export enum ArchivingTssStatusEnum {
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
	INACTIVE = 'inactive',
	DISABLED = 'disabled',
	DELETED = 'deleted'
}

// UI enums *********************************************************
